import { z } from 'zod'

import { pagedSchema } from '../core'

const text = z.string().nullish()

/** A parent-child link between two accounts (SupplyLogic above a supplier or a client, a supplier above its clients). */
export const accountRelationshipSchema = z.object({
  id: z.string(),
  parentAccountId: z.string(),
  parentAccountType: text,
  childAccountId: z.string(),
  childAccountType: text,
  relationshipType: text,
  isActive: z.boolean().default(true),
  createdBy: text,
  createdAt: z.string(),
  updatedAt: text,
})
export type AccountRelationshipDto = z.infer<typeof accountRelationshipSchema>

export const accountRelationshipPageSchema = pagedSchema(accountRelationshipSchema)

/** POST /api/v1/account-relationships. The parent is the account above, the child the one below. */
export interface AccountRelationshipCreateBody {
  parentAccountId: string
  childAccountId: string
  createdBy: string
}

/** PUT /api/v1/account-relationships/{id} */
export interface AccountRelationshipUpdateBody {
  parentAccountId: string
  childAccountId: string
  isActive: boolean
}

export interface AccountRelationshipFilters {
  parentAccountId?: string
  childAccountId?: string
  isActive?: boolean
}
